module.exports = {
  name: {
    home: '首页',
    data: '数据',
    permission: '权限',
    member: '成员',
    agent: '代理',
    setting: '设置',
    login: '登陆',
    logout: '登出',
    country: '国家',
    phone: '手机',
    account: '账号',
    sms_code: '验证码',
    password: '密码',
    to: '至',
    all: '所有',
    every: '每',
    source: '源',
    target: '目标',
    success: '成功',
    succeed: '成功',
    failed: '失败',
    error: '错误',
    status: '状态',
    state: '状态',
    detail: '详情',
    add: '添加',
    added: '添加',
    name: '名称',
    type: '类型',
    secret_type: '安全类型',
    method: '方式',
    cancel: '取消',
    canceled: '取消',
    ok: '确定',
    run: '运行',
    running: '运行',
    action: '操作',
    actions: '操作',
    delete: '删除',
    deleted: '删除',
    pass: '跳过',
    passed: '跳过',
    hit: '提示',
    rename: '重命名',
    save: '保存',
    config: '配置',
    schedule: '调度',
    transaction: '转换',
    pipeline: '管道',
    history: '历史',
    generate: '生成',
    address: '地址',
    edit: '编辑',
    copy: '复制',
    paste: '粘贴',
    field: '字段',
    writeback: '回写',
    digit: '位数',
    start: '开始',
    end: '结束',
    rule: '规则',
    minute: '分',
    hour: '时',
    day: '天',
    week: '周',
    month: '月',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期天',
    value: '值',
    team: '组织',
    log: '日志',
    search: '搜索',
    query: '查询',
    reset: '重置',
    variable: '变量',
    profile: '个人信息',
    username: '用户名称',
    nickname: '用户昵称',
    bind: '绑定',
    unbind: '解绑',
    change: '修改',
    code: '编码',
    authorization: '授权',
    storage: '存储',
    record: '记录',
    group: '组织',
    pending: '等待',
    company: '公司',
    check: '验证',
    doc: '文档',
    default: '默认',
    open: '开放',
    received: '已接收',
    mapping: '映射',
    exit: '退出',
    continue: '继续',
    desc: '说明',
    proc: '进程',
    download: '下载',
    view: '查看',
    trigger: '触发',
    schema: '数据结构',
    simple: '简易',
    manual: '手动',
    loop: '循环',
    split: '列表分割',
    break: '中止',
    env: '环境变量',
    get_output: '获取输出',
    json: 'Json',
    agent_sql: 'SQL',
    http: 'HTTP',
    pipeline_link: '管道串联',
    jq: 'JQ',
    json_schema: 'JsonSchema',
    open_webhook: '开启 WebHook',
    open_notify: '开启提醒',
    open_alert: '开启警告',
    always_debug: '全局Debug',
    input_describe: '输入描述',
    output_describe: '输出描述',
    step: '步骤',
    record_write: '记录写入',
    record_read: '记录读取',
    record_confirm: '记录确认',
    pipeline_usage: '管道使用情况',
    pipeline_count: '管道数量',
    proc_times: '执行次数',
    common_pipeline: '常用管道',
    recent_proc: '最近执行',
    direct: '直连',
    db_config: '数据库配置',
    db_type: '数据库类型',
    host: '主机',
    port: '端口',
    db_name: '数据库',
    user_name: '用户名',
    redis_check: '数据验证',
    agent_file: '读写文件',
    file_path: '文件路径',
    upload_file: '上传文件',
    file_name: '文件名',
    customer_condition: '自定义条件',
    mark: '标记',
    warning: '警告',
    receive_status: '最后接收状态',
    last_receive_time: '最后接收时间',
    error_info: '最后接收错误信息',
    receive_details: '最后接收详情',
    click_to_view: '查看',
    start_at: '开始于',
    interval: '间隔',
    timing: '定时',
    frequency: '频率',
    effective_time_period: '有效时间段',
    webservice: 'webservice',
    oss: '腾讯云 Oss',
    oss_config: 'Oss配置',
    bucket_name: '存储桶',
    app_id: 'APP ID',
    secret_id: 'Secret ID',
    secret_key: 'Secret Key',
    region: '区域',
    init: '初始化',
    edge: '边缘',
    update: '更新',
    last_update_time: '最后更新时间',
    tag: '标签',
    xml2json: 'Xml To Json',
    publish: 'Publish',
    topic_name: 'Topic 名称',
    subscribe_name: '订阅名称',
    create_topic: '创建Topic',
    create_subscribe: '创建订阅',
    edit_subscribe: '编辑订阅',
    create: '创建',
    listen_method: '订阅方式',
    delete_topic: '删除Topic',
    delete_subscribe: '删除订阅',
    publish_message: '发布消息',
    client_list: '设备列表',
    topic_manage: 'Topic管理',
    client_id: '设备ID',
    client_ip: '设备IP',
    get_token: '获取Token',
    context_type: '消息格式',
    step_info: '步骤信息',
    jump_detail: '跳转详情',
    branch_judge: '分支判断',
    judging_condition: '判断条件',
    action_type: '操作类型',
    file_data: '文件数据',
    amqp: 'AMQP',
    new_link: '新建连接',
    server: '服务器',
    user: '用户名',
    exchange: 'Exchange',
    queue: 'Queue',
    delete_amqp: '删除连接',
    exchange_type: 'Exchange Type',
    route_key: 'Route Key',
    auto_ack: 'Auto ACK',
    message_count: '消息数量',
    amqp_ack: 'AMQP消息确认',
    auto_delete: '自动删除',
    durable: 'Durable',
    download_file: '下载文件',
    suffix: '后缀',
    edge_status: '服务器连接状态',
    expire_time: '过期时间'
  },
  message: {
    please_enter: '请输入',
    please_choice: '请选择',
    please_enter_something: '请输入{msg}',
    please_choice_something: '请选择{msg}',
    get_code: '获取验证码',
    get_sms_code: '获取验证码',
    try_again: '重试',
    date_start: '开始日期',
    date_end: '结束日期',
    finished_at: '完成实际',
    data_status: '数据状态',
    recent_transfer: '最近转换',
    latest_week: '最后一周',
    latest_month: '最后一个月',
    last_three_months: '最后三个月',
    latest_transfer_time: '最后转换时间',
    delete_confirm: '该操作将删除数据，确定继续吗？',
    reset_confirm: '该操作将重置记录，重置后您将再一次接收到该记录，确定继续吗？',
    pass_confirm: '该操作将跳过记录，跳过后您将不再接收该记录，确定继续吗？',
    something_invalid: '{msg}无效',
    something_required: '{msg}是必填的!',
    something_succeed: '{msg}成功!',
    something_failed: '{msg}失败!',
    operation_succeed: '操作成功!',
    operation_failed: '操作失败!',
    running_succeed: '运行成功!',
    running_failed: '运行失败!',
    data_format: '数据格式',
    string_list: '字符串列表',
    string_regexp: '正则表达式',
    paste_formated_json: '请输入格式化的JSON',
    copy_succeed: '复制成功!',
    copy_failed: '复制失败!',
    new_node: '新节点',
    api_request_failed: '数据请求失败!',
    schedule_hour: '每小时{minute} 分',
    schedule_day: '每天 {hour}:{minute}',
    schedule_week: '{weekday} 的 {hour}:{minute}',
    schedule_month: '每月 {day_of_month} 号的 {hour}:{minute}',
    please_choice_target_data: '请选择目标数据',
    reset_agent_key_hit: '重置后旧Key将无效，确定继续吗？',
    env_variable: '环境变量',
    add_team: '创建组织',
    change_to_team: '您已进入 {msg} 组织',
    something_alert: '{msg}预警',
    change_something: '修改{msg}',
    phone_source: '旧手机',
    phone_new: '新手机',
    phone_no_bind: '请先绑定手机!',
    password_new: '新密码',
    password_confirm: '确认密码',
    password_inconsistent: '新密码和确认密码不一致',
    password_invalid: '密码无效, 长度必须为{min}到{max}位范围',
    record_time: '记录时间',
    update_time: '更新时间',
    deleted_time: '删除时间',
    please_run_in_transaction: '请在转换中运行',
    user_not_exist_invite: '用户不存在，您要邀请他吗？',
    for_check: '作为验证',
    open_data_is_readonly: '这是开放的数据，它是只读的!',
    error_action: '错误后动作',
    error_action_hint_exit: '如果Process执行的时候碰到错误，则报错退出不再继续后续操作。',
    error_action_hint_continue: '如果Process有多部分操作，比如拆分成多次Push。那么碰到错误的时候将记录该Trace错误，并继续执行后续任务。',
    error_retry_times: '错误后重试次数',
    action_batch: '批量操作',
    change_to_new_version: '切换到新版本',
    back_to_old_version: '退回老版本',
    change_version: '切换版本',
    merge_result: '合并结果',
    list_number: '列表数量',
    pipeline_limit: '管道数量到达上限',
    proc_limit: '执行次数到达上限',
    auto_generate: '(如不填写将会自动生成)',
    mqtt_service_info: '服务地址: mqtts://m.dotflow.cn:80'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js